import { render, staticRenderFns } from "./AdminManageApplications.vue?vue&type=template&id=48e16d21&"
import script from "./AdminManageApplications.vue?vue&type=script&lang=js&"
export * from "./AdminManageApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports